import type { Point2d, Vector2d } from "."

export const moveOnVector = (
  v: Vector2d,
): { point: (p: Point2d) => Point2d } => ({
  point: (p) => ({
    x: p.x + v.d * Math.cos(v.r),
    y: p.y + v.d * Math.sin(v.r),
  }),
})
